(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-sliders"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var $ = window.jQuery;
  if (!$) return;

  function getControls(key) {
    // gets the controls wrapper (not the carousel)
    return $('[data-carousel="' + key + '"]').filter(function () {
      return !$(this).hasClass('owl-carousel');
    });
  }

  function updateUI($carousel, key) {
    var inst = $carousel.data('owl.carousel');
    if (!inst) return;

    var index = inst.relative(inst.current()); // 0-based
    var total = inst.items().length;

    // visible items (current responsive setting)
    var visible = parseInt(inst.settings.items, 10) || 1;

    // arrows
    var $controls = getControls(key);
    var $prev = $controls.find('.owl-prev');
    var $next = $controls.find('.owl-next');

    //$prev.toggleClass('is-disabled', index <= 0);
    //$next.toggleClass('is-disabled', (index + visible) >= total);

    // progress (like your screenshot)
    // progress based on how far you've scrolled through items
    // total scrollable distance
    var maxIndex = Math.max(total - visible, 0);

    // progress including visible slides
    var pct;

    if (maxIndex === 0) {
    pct = 100;
    } else {
    pct = ((index + visible) / total) * 100;
    }

    $controls.find('.owl-progress__bar').css('width', pct + '%');
  }

  // Init each carousel + bind updates
  $('.owl-carousel[data-carousel]').each(function () {
    var $carousel = $(this);
    var key = $carousel.data('carousel');
    var slide_count = parseInt($carousel.data('items'), 10) || 1;

    $carousel.owlCarousel({
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplaySpeed: 800,
      smartSpeed: 800,
      margin: 10,
      responsiveClass: true,
      responsive: {
        0: { items: 1, nav: false, stagePadding: 50 },
        600: { items: slide_count, nav: false, stagePadding: 20 },
        1000: { items: slide_count, nav: false }
      }
    });

    // update after init + on every change
    // $carousel.on('initialized.owl.carousel changed.owl.carousel resized.owl.carousel', function () {
    //   updateUI($carousel, key);
    // });

    // safety: first paint
    // setTimeout(function () { updateUI($carousel, key); }, 0);
  });

  // Buttons (scoped per data-carousel)
  $(document).on('click', '.owl-prev, .owl-next', function (e) {
    e.preventDefault();

    var $controls = $(this).closest('[data-carousel]');
    var key = $controls.data('carousel');
    var $carousel = $('.owl-carousel[data-carousel="' + key + '"]');
    if (!$carousel.length) return;

    //if ($(this).hasClass('is-disabled')) return;

    $carousel.trigger($(this).hasClass('owl-prev') ? 'prev.owl.carousel' : 'next.owl.carousel');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-not-found"]) return;
  try {
    
  $(function () {
    var seconds = 3;
    var $sec = $('#sec');

    $sec.text(seconds);

    var countdown = setInterval(function () {
      seconds--;

      if (seconds <= 0) {
        clearInterval(countdown);

        var path = window.location.pathname;
        var redirectUrl = '/';

        if (path === '/zh-hant' || path.indexOf('/zh-hant/') === 0) {
          redirectUrl = '/zh-hant';
        } else if (path === '/zh-hans' || path.indexOf('/zh-hans/') === 0) {
          redirectUrl = '/zh-hans';
        }

        window.location.href = redirectUrl;
        return;
      }

      $sec.text(seconds);
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  $(".slideshow__slide.is-selected").on("click", function() {
    var slide_href = $(this).attr("href");
    window.location.href = slide_href;
  })

  } catch(e) { console.error(e); }
})();
})();
